/**
 * The spacing, radius and border scales.
 *
 * A geometric-ish scale rather than every multiple of 4, because a scale you can exhaust is a scale
 * people stay inside. Eight steps cover a component, and `section` exists only to separate the
 * bands of a marketing page. `xxs` is the gap between an icon and its text inside a badge, and
 * `xl2` separates the sections of a compact signed-in page.
 *
 * A signed-in page gutter is `lg` on a phone, `xl` on a tablet and `xl2` on a desktop.
 */
import * as stylex from "@stylexjs/stylex";
export const space = {
  xxs: "var(--x1p4vr8)",
  xs: "var(--x1t7ptdk)",
  sm: "var(--x1pu4xfv)",
  md: "var(--xtekhgw)",
  lg: "var(--x1k2p3nt)",
  xl: "var(--xo19qrd)",
  xl2: "var(--x1bp6mqj)",
  xxl: "var(--xz9zfsn)",
  section: "var(--xrey7e2)",
  __varGroupHash__: "x1p8dr7i"
};

/**
 * Radius by role. `sm` is a badge with text, a checkbox or a tooltip. `md` is every control on a
 * signed-in screen: button, input, select, menu item and compact chip. `lg` is a card, panel,
 * dialog or sheet, and a sheet rounds only its free edge. `full` is an avatar, a status dot, a pill
 * chip or the marketing call to action. `xl` belongs to the marketing site's large bands.
 *
 * The pill shape is for the marketing site and the checkout button. Inside the signed-in app a
 * control is `md`, and an inner radius is smaller than the one around it: a 14px card holds 8px
 * controls.
 */
export const radius = {
  sm: "var(--xku44r2)",
  md: "var(--x1qn55o8)",
  lg: "var(--x1br3po1)",
  xl: "var(--xvre9vl)",
  full: "var(--xvkm7dm)",
  __varGroupHash__: "x14cw03f"
};

/**
 * Border widths. `hair` is every border. `thick` is a focus ring, a selected tab's underline and
 * the current nav marker.
 *
 * The focus offsets place the ring 2px outside a standalone control, or 2px inside a list row,
 * table row, menu item or sidebar link, where a parent with `overflow: hidden` would clip a ring
 * drawn outside.
 */
export const border = {
  hair: "var(--x1fbknne)",
  thick: "var(--x1rc3s1e)",
  focusOffset: "var(--x4pn87q)",
  focusOffsetInset: "var(--xzh17nj)",
  __varGroupHash__: "xo4rbq5"
};